"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/primitives";
import { SectionError } from "@/components/ui/states";

/* Route-level boundary. Anything a page throws lands here instead of a blank
   screen, and `reset` re-runs the render so a transient API failure recovers
   without a full reload. */
export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[route]", error);
  }, [error]);

  return (
    <div className="mx-auto flex max-w-[1144px] flex-col px-[16px] py-[64px] lg:px-[24px]">
      <div className="rounded-2xl bg-elevation-1">
        <SectionError
          title="This page didn’t load"
          body="Something on our side didn’t answer. Try again in a moment — the rest of the site is unaffected."
          action={
            <div className="flex items-center gap-2">
              <Button onClick={reset}>Try again</Button>
              {error.digest && (
                <span className="text-[9px] font-bold uppercase tracking-[0.14em] text-fg-disabled">
                  {error.digest}
                </span>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}
